"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var SUBSCRIPTION_DEFINITION_URI = 'subscriptions/v1/definitions';
var SUBSCRIPTION_TRANSLATIONS_URI = 'subscriptions/v1/translations';
var SUBSCRIPTION_DEPENDENCY_URI = 'subscriptions/v1/dependency';
var TIMEOUT = 7000;

var SubscriptionDefinitionsAPI =
/*#__PURE__*/
function () {
  function SubscriptionDefinitionsAPI() {
    (0, _classCallCheck2.default)(this, SubscriptionDefinitionsAPI);
  }

  (0, _createClass2.default)(SubscriptionDefinitionsAPI, null, [{
    key: "getSubscriptionDefinitions",
    value: function getSubscriptionDefinitions() {
      return _apiClient.default.get("" + SUBSCRIPTION_TRANSLATIONS_URI, {
        query: {
          clientimeout: TIMEOUT,
          includeInactive: true,
          includeInternal: true
        }
      });
    }
  }, {
    key: "getDependentEmailsForSubscription",
    value: function getDependentEmailsForSubscription(subscriptionId) {
      return _apiClient.default.get(SUBSCRIPTION_DEPENDENCY_URI + "/" + subscriptionId + "/email-content", {
        query: {
          clientimeout: TIMEOUT
        }
      });
    }
  }, {
    key: "createSubsciptionDefinition",
    value: function createSubsciptionDefinition(subscriptionDefinition) {
      return _apiClient.default.post("" + SUBSCRIPTION_DEFINITION_URI, {
        query: {
          clientimeout: TIMEOUT
        },
        data: subscriptionDefinition
      });
    }
  }, {
    key: "createSubscriptionTranslation",
    value: function createSubscriptionTranslation(subscriptionTranslation) {
      return _apiClient.default.post("" + SUBSCRIPTION_TRANSLATIONS_URI, {
        query: {
          clienttimeout: TIMEOUT
        },
        data: subscriptionTranslation
      });
    }
  }, {
    key: "updateSubsciptionDefinition",
    value: function updateSubsciptionDefinition(subscriptionDefinitionObj) {
      var subscriptionDefinition = subscriptionDefinitionObj.subscriptionDefinition;
      return _apiClient.default.put(SUBSCRIPTION_TRANSLATIONS_URI + "/update/with-subscription-id/" + subscriptionDefinition.subscriptionId, {
        query: {
          clientimeout: TIMEOUT
        },
        data: subscriptionDefinitionObj
      });
    }
  }, {
    key: "updateSubscriptionDefinitions",
    value: function updateSubscriptionDefinitions(data) {
      return _apiClient.default.put(SUBSCRIPTION_TRANSLATIONS_URI + "/bulk-update", {
        query: {
          clientimeout: TIMEOUT
        },
        data: data
      });
    }
  }, {
    key: "updateSubscriptionPositions",
    value: function updateSubscriptionPositions(data) {
      return _apiClient.default.put(SUBSCRIPTION_DEFINITION_URI + "/update-positions", {
        query: {
          clientimeout: TIMEOUT
        },
        data: data
      });
    }
  }, {
    key: "deleteSubscriptionTranslation",
    value: function deleteSubscriptionTranslation(_ref) {
      var subscriptionId = _ref.subscriptionId,
          languageCode = _ref.languageCode;
      return _apiClient.default.delete(SUBSCRIPTION_TRANSLATIONS_URI + "/" + subscriptionId + "/" + languageCode, {
        query: {
          clientimeout: TIMEOUT
        }
      });
    }
  }]);
  return SubscriptionDefinitionsAPI;
}();

exports.default = SubscriptionDefinitionsAPI;
module.exports = exports.default;